module.exports = __webpack_public_path__ + "img/md-cash.51d067e0.svg";